module.exports = __webpack_public_path__ + "media/images/icons/apple-3aed0776e9335292e633e1045af09b6a.png";